import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { GET_URL } from '@utils/api/endpoints';
import { BaseError } from '@utils/types/shared/base';
import { CustomerExceedancesResponse } from '@utils/types/back-office/exceedances';

export const useGetCustomerExceedances = (customerId: string | number) => {
  const fetchExceedances = async () => {
    const { adminCustomerExceedances } = GET_URL(String(customerId));
    const { data } = await Axios.get<CustomerExceedancesResponse>(
      adminCustomerExceedances
    );
    return data;
  };

  return useQuery<CustomerExceedancesResponse, AxiosError<BaseError>>(
    ['customerExceedances', customerId],
    fetchExceedances,
    {
      enabled: !!customerId,
      staleTime: 60_000,
      cacheTime: 5 * 60 * 1000
    }
  );
};
